import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminTagsList from "@/features/tags/components/admin/AdminTagsList";
import { useTagsPermissions } from "@/pages/admin/tags";

export const Route = createFileRoute("/app/admin/tags/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanViewAllMaterials, userCanViewAllTags, userCanEditAllTags } = useTagsPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Tags", link: null },
        ]}
      />
      <h1>Tag Management</h1>

      {userCanEditAllTags && (
        <p>
          <Button
            color="primary"
            component={Link}
            to="/app/admin/tags/new"
            variant="contained"
            size="small"
            disabled={!userCanEditAllTags}
          >
            Add Tag
          </Button>
        </p>
      )}

      <AdminTagsList
        itemsPerPage={25}
        renderVersion={0}
        tableSize="medium"
        userCanViewAllMaterials={userCanViewAllMaterials}
        userCanEditAllTags={userCanEditAllTags}
        userCanViewAllTags={userCanViewAllTags}
      />
    </>
  );
}
